import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from './accordion.component';
import { IconModule } from '../icon/icon.module';
import { AccordionItemModule } from './accordion-item.module';

@NgModule({
  declarations: [AccordionComponent],
  imports: [CommonModule, IconModule, AccordionItemModule],
  exports: [AccordionComponent],
})
export class AccordionModule {}
